import React from 'react';
import  Config from '../Helpers/Config';

function Login() {
    return (

        <div className="bg-white vh-100">
        <div className="container-fluid">

            <div className="">
                <div className='col-md-12'>
                <div className=" col-md-6 text-center mx-auto">
                      <img className= "logo-style" src={"https://assets.investera.com/investera-client-configs/clients/"+Config.provider+"/logo.png"} width="100" title="Dimah logo" />
                </div>       
                </div>
                <div className='col-md-12'>
                <div 
                className="col-md-6 mx-auto">
                                   

                        <input type="text" className="new-line  input-text" placeholder="Username/Email/Mobile " aria-label="Username" aria-describedby="basic-addon1" required="required" />
                        <p className='hint-text'> Mobile No. Format: 965xxxxxxxx </p> 
                        <input type="password" className=" new-line input-text"  name="Password" id="password" placeholder="Password" required="required"/> 

                        <span> <a  className='forget-password-text' href = "#"> Forget Password?</a> </span>  <br></br><br></br>

                        <button className='login-btn-style  new-line' type="button"> Login</button> <br></br><br></br> <br></br> 
                        <br></br> 

                        <p className='faq-condition-text'> By continuing, you agree to our <a style={{  color: '#006580'}} href = "#"> User Agreement</a>  , <br></br>
                        <a style={{  color: '#006580'}} href = "#"> Privacy Policy</a> and <a style={{  color: '#006580'}}  href = "#"> CIS Cayman Island & Jersey notice</a> </p>

                        <hr  />

                        <p className='faq-text'> FAQ</p>
                        
                </div>
            </div>
            </div>
        </div>
        </div>
    )
}

export default Login
